import { fetchFinance } from "utils/api";

export const queryMdr = async (params) => {
  return await fetchFinance("/action", {
    action: "getMdr",
    ...params,
  });
};

export const queryActivityDetail = async (params) => {
  return await fetchFinance("/sales/activity", {
    type: "detail",
    page: 0,
    size: 10,
    ...params,
  });
};
